import styled from 'styled-components';

import { Icon } from '@/ui/Icon';
import { RLocationType } from '@/store/v2';

type LiveEventSessionFormat = RLocationType;

const formatToIcon: Record<LiveEventSessionFormat, 'location-pin' | 'link'> = {
  IN_PERSON: 'location-pin',
  ONLINE: 'link',
};

const formatToLabel: Record<LiveEventSessionFormat, string> = {
  IN_PERSON: 'In person',
  ONLINE: 'Online',
};

export const DateStyled = styled.div`
  ${({ theme }) => theme.typography.caption};
`;

export const FormatStyled = styled.div`
  ${({ theme }) => theme.typography.caption};
`;

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MetaRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.neutral.outline2};
`;

type LiveEventSessionCardMetaProps = {
  date: string;
  type?: LiveEventSessionFormat;
};

export const LiveEventSessionCardMeta = ({ date, type = RLocationType.Online }: LiveEventSessionCardMetaProps): JSX.Element => {
  return (
    <RootStyled>
      <MetaRowStyled>
        <Icon size="xs" icon={['far', 'calendar']} />
        <DateStyled>{date}</DateStyled>
      </MetaRowStyled>
      <MetaRowStyled>
        <Icon size="xs" icon={['far', formatToIcon[type]]} />
        <FormatStyled>{formatToLabel[type]}</FormatStyled>
      </MetaRowStyled>
    </RootStyled>
  );
};
